import { AuthGuard } from '../../shared/guards/AuthGuard';
import { ProposalEditPresentation } from './components';
import { Sidebar } from '../../shared/components';

export const ProposalEditPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <ProposalEditPresentation />
            </Sidebar>
        </AuthGuard>
    )
};